import { takeEvery, all, call } from 'redux-saga/effects';

import * as constants from 'data/CurrentUser/constants';
import workspaceService from 'services/WorkspaceService';

import {
  saveSession,
  removeSession,
} from 'data/CurrentUser/sessionManager';

function* saveUser({ bearerToken, remember, expiry }) {
  yield call(saveSession, bearerToken, remember, expiry);
}

function* removeUser() {
  yield call(removeSession);
  yield call(workspaceService.clearSelectedWorkspace);
}

export default function* handleCurrentUser() {
  yield all([
    takeEvery(constants.SET_CURRENT_USER, saveUser),
    takeEvery(constants.UNSET_CURRENT_USER, removeUser),
  ]);
}
